import * as ROUNDS_API from '@/constants/roundsApiEndpoints'
import router from '@/router'

// Room Service Plugin
class RoomService {
  constructor (Vue) {
    this.Vue = Vue;
    this._store = Vue.roomsStore;
  }

  refreshData (teamId) {
    if (!teamId) {
      teamId = this.Vue.$teamService.currentTeamId
    }
    if (this.Vue.$auth.watch.authenticated && !!teamId) {
      var options = {
        credentials: true,
        headers: {
          'Content-Type': 'application/json'
        },
        params: {
          teamId: teamId
        }
      }
      this.Vue.http.get(ROUNDS_API['API_ENDPOINT_ROOMS'], options).then(res => res.json()).then(
        // Success Calback
        response => {
          if (!response || response.errorMessage) {
            // Error Callback
            this.refreshDataFailureCallback(response);
          } else {
            this._store.dispatch('updateRooms', { items: response.rooms, teamId: teamId });
            this._store.dispatch('updateInventory', { items: response.inventory, teamId: teamId });
          }
        },

        // Error Callback
        response => {
          this.refreshDataFailureCallback(response);
        }
      );
    }
  }

  refreshDataFailureCallback (response) {
    // Log exception in Google Analytics
    if (response && (response.length || Object.keys(response).length)) {
      const exception = response.errorMessage || response;
      this.Vue.$ga.exception(exception);
    }

    // Log user out if request authorization fails
    if (response.errorMessage && response.errorMessage.match(/^E_AUTH_.+/)) {
      this.Vue.$auth.logout().then(router.accessDenied);
    }
  }

  preCacheRoomsForCurrentUserTeams () {
    // Fetch data and cache rooms lists for current user's teams
    // TODO: Maybe check how long it's been since data was fetched and set a minimum refresh interval
    if (!!this.Vue.$teamService.currentUserTeamIds.length) {
      for (var teamId of this.Vue.$teamService.currentUserTeamIds) {
        this.refreshData(teamId);
      }
    }
  }

  get rooms () {
    if (!!this.Vue.$teamService.currentTeamId && !!this._store.state.RoomsCache.rooms[this.Vue.$teamService.currentTeamId]) {
      return this._store.state.RoomsCache.rooms[this.Vue.$teamService.currentTeamId].filter(it => it.active_status === 'Yes');
    }
    return [];
  }

  get inventory () {
    if (!!this.Vue.$teamService.currentTeamId && !!this._store.state.RoomsCache.inventory[this.Vue.$teamService.currentTeamId]) {
      return this._store.state.RoomsCache.inventory[this.Vue.$teamService.currentTeamId]
    }
    return [];
  }

  getRoom (roomId) {
    // TODO: Possibly fetch individual room from API
    var room = {};
    var roomsFiltered = this.rooms.filter(it => it.room_id === roomId);
    if (roomsFiltered.length) {
      room = roomsFiltered.pop();
    }
    // TODO: Error if room not found
    return room;
  }

  getRoomInventory (roomId) {
    // TODO: Possibly fetch individual inventory from API
    var inventory = {};
    var inventoryFiltered = this.inventory.filter(it => it.room_id === roomId);
    if (inventoryFiltered.length) {
      inventory = inventoryFiltered.pop().items.filter(it => it.inReport && it.inReport === 'Yes');
    }
    // TODO: Error if room not found
    return inventory;
  }

  getRoomInventoryForm (roomId) {
    var form = {};
    this.getRoomInventory(roomId).forEach(val => {
      form[val.featureId] = {
        status: null,
        issueDialog: false,
        issueHelp: false,
        issueDescription: ''
      };
    });
    return form;
  }

  reset () {
    this._store.dispatch('clearCache');
  }
}

const roomService = {
  install: function (Vue, options) {
    const instance = new RoomService(Vue);
    Vue.prototype.$roomService = instance
    Vue.$roomService = instance;
  }
};

export default roomService;



// WEBPACK FOOTER //
// ./src/services/RoomService.js